import React, { useState } from 'react';
import { api } from '@/contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Download, FileSpreadsheet } from 'lucide-react';
import { toast } from 'sonner';

const EXPORT_TYPES = [
  { value: 'all', label: 'Export complet' },
  { value: 'trouves', label: 'Prospects trouvés' },
  { value: 'non_trouves', label: 'Non trouvés' },
  { value: 'rappels', label: 'Rappels du jour' },
];

export default function ExportModal({ onClose, commerciaux = [] }) {
  const [exportType, setExportType] = useState('all');
  const [commercial, setCommercial] = useState('');
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const params = { type: exportType };
      if (commercial) params.commercial_id = commercial;
      const response = await api.get('/exports/prospects', { params, responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `prospects_${exportType}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Export téléchargé');
      onClose();
    } catch {
      toast.error("Erreur d'export");
    }
    setLoading(false);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="export-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'var(--font-heading)' }}>
            <FileSpreadsheet className="w-5 h-5 text-[#0055FF]" />
            Exporter les prospects
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div>
            <label className="text-sm font-medium mb-1.5 block">Type d'export</label>
            <Select value={exportType} onValueChange={setExportType}>
              <SelectTrigger className="bg-white" data-testid="export-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {EXPORT_TYPES.map(t => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          {commerciaux.length > 0 && (
            <div>
              <label className="text-sm font-medium mb-1.5 block">Par commercial (optionnel)</label>
              <Select value={commercial} onValueChange={setCommercial}>
                <SelectTrigger className="bg-white" data-testid="export-commercial-select"><SelectValue placeholder="Tous les commerciaux" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Tous</SelectItem>
                  {commerciaux.map(c => <SelectItem key={c.id} value={c.id}>{c.prenom} {c.nom}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          )}
          <Button onClick={handleExport} disabled={loading} data-testid="download-export-btn"
            className="w-full h-10 bg-[#0055FF] hover:bg-[#0040CC] text-white gap-2">
            <Download className="w-4 h-4" /> {loading ? 'Préparation...' : 'Télécharger le fichier Excel'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
